import React, { useEffect, useState } from "react";
import SearchCard from "components/Card/SearchCard";
import useProperties from "hooks/useProperties";
import AnimatedDialogLayout from "components/Dialog/AnimatedDialogLayout";
import { ReactComponent as CloseIcon } from "assets/icons/close.svg";

const PaginatedPropertiesPopup = ({ properties, id }) => {
  const { isPaginatedPropertyPopupOpen, togglePaginatedPropertyPopup } =
    useProperties();

  const handleClosePopup = () => {
    document.body.style.overflow = "auto";
    togglePaginatedPropertyPopup(id);
  };

  return (
    <AnimatedDialogLayout
      isOpen={isPaginatedPropertyPopupOpen === id}
      onClose={handleClosePopup}
      styleDropdown={{
        height: "100%",
        maxWidth: 1550,
        width: "100%",
        paddingTop: 14,
      }}
    >
      <div className="h-full flex flex-col">
        <div className="flex my-1 z-[1] items-center justify-end">
          <CloseIcon
            onClick={handleClosePopup}
            className="w-4 h-4 cursor-pointer"
          />
        </div>
        <div className="px-[18px] mt-4 pb-[22px] flex-grow lg:mt-0 grid gap-y-[22px]">
          {properties.map((property, index) => {
            const updatedProperty = {
              ...property,
              average_gross_yield: property?.averageGrossYield,
            };
            return (
              <SearchCard
                key={property._id}
                property={updatedProperty}
                lastPropertyRef={null}
                isOrganisePage={true}
              />
            );
          })}
        </div>
      </div>
    </AnimatedDialogLayout>
  );
};

export default PaginatedPropertiesPopup;
